// extracted by css-extract-rspack-plugin
export default {"heading":"_a96d9e9f","body":"_31ff9c67","image":"_b4fe6890"};